import { render, staticRenderFns } from "./Supply.vue?vue&type=template&id=3a53e9f6&scoped=true"
import script from "./Supply.vue?vue&type=script&lang=js"
export * from "./Supply.vue?vue&type=script&lang=js"
import style0 from "./Supply.vue?vue&type=style&index=0&id=3a53e9f6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53e9f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a53e9f6')) {
      api.createRecord('3a53e9f6', component.options)
    } else {
      api.reload('3a53e9f6', component.options)
    }
    module.hot.accept("./Supply.vue?vue&type=template&id=3a53e9f6&scoped=true", function () {
      api.rerender('3a53e9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supply/Supply.vue"
export default component.exports